import { defineStore } from "pinia";
import { useApi } from "~~/lib";
import type { IMenuHeaderItem, IMenuItem, IMenuPage } from "~~/types/menu";
import { useMainStore } from "./mainState";


export const useMenuStore = defineStore('menu', () => {

    const mainMenu: Ref<null | IMenuPage[]> = shallowRef(null);
    const headerMenu = shallowRef<IMenuHeaderItem[]>([]);

    const mainStore = useMainStore();

    const api = useApi();

    async function tryInit() {
        if (!mainMenu.value?.length) {
            return init();
        }
    }

    async function init() {
        const data = await api.get<IMenuPage[]>('/rest/v2/menu', {_c: mainStore.location!.city.content});
        if (!data) {
            return;
        }

        mainMenu.value = data;
    }

    return {tryInit, mainMenu, headerMenu};
});
